
import React from 'react';

const regions = 'https://static.bodyspec.com/at/f7/80/f780b506980e7784';

import DynamicAsset from 'components/DynamicAsset';

import * as styles from './styles.module.scss';

export const Static = () => {
	return (
		<div className={styles.wrapper}>
			<h2>The four regions</h2>
			<div className={styles.intro}>
				<p>
					These charts divide your body into 4 regions and provide the composition breakdown for each. BodySpec automatically
					tracks these regions over time to chart regional progress.
				</p>
			</div>
			<div className={styles.diagram}>
				<DynamicAsset imageSrc={regions} />
			</div>
		</div>
	);
};
